// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__WqFMJ"};